import AchievementItem from '@/components/Achievements/AcievementsCards/AchievementItem';
import { SerializedEditorState } from 'node_modules/lexical/LexicalEditorState';
import { ReactNode } from 'react';

interface AchievementsListProps {
  achievementsList: Array<{
    icon?: string | { url: string; alt: string };
    width?: number;
    height?: number;
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  }>;
}

export default function AchievementsList({ achievementsList }: AchievementsListProps) {
  return (
    <div data-meta="AchievementsList" className="achievement-container">
      {achievementsList.map((item, index) => (
        <AchievementItem key={index} achievementItem={item} />
      ))}
    </div>
  );
}
